import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";
import { useResponsiveness } from "hooks/useResponsiveness";

const JobsMobile = loadable(() => import("./Jobs"), {
  fallback: <FullPageLoader />,
});

const JobsDesktop = loadable(() => import("./Desktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { windowWidth, isAbove } = useResponsiveness();
  const isDesktop = isAbove("sm");

  return (
    <ErrorBoundary>
      {windowWidth === null && <FullPageLoader />}
      {windowWidth !== null && isDesktop && <JobsDesktop {...props} />}
      {windowWidth !== null && !isDesktop && <JobsMobile {...props} />}
    </ErrorBoundary>
  );
};
